<template>
  <div class="birthday-freebie-banner">
    <h3 class="header-4">B'day Freebie</h3>
    <span class="body-small">Want FREE snack chips EVERY DAY of your birthday month? Just tell us when it is!</span>
  </div>
</template>

<style lang="scss" scoped>
  .birthday-freebie-banner {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 12px 16px;

    border-radius: 4px;

    background-color: var(--color-base-green);

    * {
      margin: 0;
      text-align: center;
      color: var(--color-base-white);
    }
  }
</style>
